import {axios} from "@/api/config";
// 查询【请填写功能名称】列表
export function listVideoDate(params) {
  return axios.get(`/videoDate/list`, params, true);
}


// 查询【请填写功能名称】详细
export function getVideoDate(id) {
  return axios.get(`/videoDate/${id}`, id, true)
}



